






















































































































import Vue from 'vue'

import moment from 'moment'
import { AlarmHistory } from '@/api/alarm'

const momentDurationFormatSetup = require('moment-duration-format')
momentDurationFormatSetup(moment)

export default Vue.extend({
  name: 'ComponentName',
  props: {
    value: Array,
  },
  data() {
    return {
      fields: [
        { key: 'status', thClass: 'column-status', tdClass: 'column-status' },
        { key: 'startDate', thClass: 'time-value' },
        { key: 'startTime', thClass: 'time-value' },
        { key: 'startValue', thClass: 'time-value' },

        { key: 'endDate', thClass: 'time-value' },
        { key: 'endTime', thClass: 'time-value' },
        // { key: 'endValue', thClass: 'time-value' },

        // { key: 'ackDate', thClass: 'time-value' },
        // { key: 'ackTime', thClass: 'time-value' },
        // { key: 'ackValue', thClass: 'time-value' },

        { key: 'class', thClass: 'column-class' },
        { key: 'duration', thClass: 'time-value', show: false },
        { key: 'text', label: 'Message' },
        {
          key: 'show_details',
          label: '',
          thStyle: 'width: 120px',
          tdStyle: 'text-center',
        },
      ],

      currentPage: 1,
      model: {},
    }
  },
  methods: {
    getDate(v: Date): string {
      const m = moment(v)
      if (m.isValid()) {
        return m.format('DD-MM-YYYY')
      } else {
        return ''
      }
    },
    getTime(v: Date): string {
      const m = moment(v)
      if (m.isValid()) {
        return m.format('HH:mm:ss')
      } else {
        return ''
      }
    },

    // eslint-disable-next-line
    getIncomingValue(item: AlarmHistory): any {
      const ackIndex = item.status.indexOf('I')
      if (typeof item.values[ackIndex] == 'number') {
        return item.values[ackIndex].toFixed(3)
      }
      return item.values[ackIndex]
    },

    // eslint-disable-next-line
    getAckValue(item: AlarmHistory): any {
      const ackIndex = item.status.indexOf('A')
      if (typeof item.values[ackIndex] == 'number') {
        return item.values[ackIndex].toFixed(3)
      }
      return item.values[ackIndex]
    },

    // eslint-disable-next-line
    getGoingValue(item: AlarmHistory): any {
      const ackIndex = item.status.indexOf('G')
      if (typeof item.values[ackIndex] == 'number') {
        return item.values[ackIndex].toFixed(3)
      }
      return item.values[ackIndex]
    },

    getDuration(v: AlarmHistory): string {
      let ms = 0
      if (v.status.toUpperCase().indexOf('G') == -1) {
        ms = moment().diff(moment(v.createdAt))
      } else {
        ms = moment(v.goingTime).diff(moment(v.createdAt))
      }

      // eslint-disable-next-line
      return (moment.duration(ms) as any).format()
    },

    rowClass(item: AlarmHistory, type: string): string[] {
      const cls: string[] = [`alarm-${item.class}`]

      if (!item || type !== 'row') return cls

      if (item.status.indexOf('I') != -1) {
        cls.push('active')
      }

      if (item.status.indexOf('A') != -1) {
        cls.push('ack')
      }

      if (item.status.indexOf('G') != -1) {
        cls.push('going')
      }

      return cls
    },
  },
  watch: {
    value: function(val) {
      this.model = val
    },
  },
  created() {
    this.model = this.value
  },
})
